import moment from 'moment';
import lodashGet from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { api } from '@/api/api';
import { ERequestDelayTime } from '@/api/utils';
export class AddressBookNewApiImpl {
    constructor() {
        this.name = 'addressBookNewApiImpl';
        this.http = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
        this.eventApi = api.getEventApi();
        this.createTypeMap = undefined;
    }
    init() {
        return this.name;
    }
    afterLoadFinish() {
        if (!process.env.BUILD_ISEDM)
            return this.name;
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser)
            return this.name;
        setTimeout(() => {
            this.initCreateTypeMap();
        }, ERequestDelayTime.middle);
        return this.name;
    }
    async initCreateTypeMap() {
        if (this.createTypeMap) {
            return;
        }
        const createTypeList = await this.getAllCreateTypeList();
        createTypeList.forEach(item => {
            if (!this.createTypeMap) {
                this.createTypeMap = {};
            }
            this.createTypeMap[item.id] = item.label;
        });
    }
    errorHandler(error) {
        var _a;
        this.eventApi.sendSysEvent({
            auto: true,
            eventSeq: 0,
            eventName: 'error',
            eventLevel: 'error',
            eventData: {
                title: (error === null || error === void 0 ? void 0 : error.message) || ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) || '网络错误',
                content: '',
                popupType: 'toast',
                popupLevel: 'error',
            },
        });
    }
    async get(url, req, config) {
        try {
            const { data } = await this.http.get(url, req, config);
            if (!data) {
                throw new Error('unknown');
            }
            if (!data.success) {
                throw data;
            }
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    async post(url, body, config) {
        config = Object.assign({ contentType: 'json', noEnqueue: false }, (config || {}));
        try {
            const { data } = await this.http.post(url, body, config);
            if (!data)
                throw new Error('unknown');
            if (!data.success)
                throw data;
            return data.data;
        }
        catch (error) {
            const { toastError = true, errorTitle } = config || {};
            toastError && this.errorHandler(errorTitle ? { message: errorTitle } : error);
            return Promise.reject(error);
        }
    }
    async getGroupList(params) {
        const url = this.systemApi.getUrl('getMarktingGroupList');
        return this.post(url, params);
    }
    async getGroupListWithPage(params) {
        const url = this.systemApi.getUrl('getMarktingGroupListWithPage');
        return this.post(url, params, { timeout: 2 * 60 * 1000 });
    }
    async createGroup(groupName) {
        const url = this.systemApi.getUrl('addMarktingGroup');
        return this.post(url, {
            group_name: groupName,
        });
    }
    async associateEdm(params) {
        const url = this.systemApi.getUrl('associateEdm');
        await this.post(url, {
            associateList: params,
        });
    }
    async addContact2Group(params) {
        const url = this.systemApi.getUrl('addMarktingContact2Group');
        await this.post(url, params);
    }
    async deleteGroup(groupId) {
        const url = this.systemApi.getUrl('deleteMarktingGroup');
        await this.post(url, {
            group_id: groupId,
        });
    }
    async updateGroup(groupId, groupName) {
        const url = this.systemApi.getUrl('editMarktingGroup');
        await this.post(url, {
            group_id: groupId,
            group_name: groupName,
        });
    }
    async addGroup2Group(params) {
        const url = this.systemApi.getUrl('addMarktingGroup2Group');
        await this.post(url, params);
    }
    async transferContact2Group(params) {
        const url = this.systemApi.getUrl('transferMarktingContact2Groups');
        await this.post(url, params);
    }
    getQuickMarktingList() {
        const url = this.systemApi.getUrl('getQuickMarktingList');
        return this.get(url);
    }
    getQuickMarktingGroupCount(params) {
        console.log('[addressBookNewApiImpl] getQuickMarktingGroupCount', params);
        const url = this.systemApi.getUrl('getQuickMarktingGroupCount');
        return this.get(url, {
            type: params.type,
            group_id: params.groupId,
        });
    }
    getQuickMarktingGuideList(params) {
        const url = this.systemApi.getUrl('getQuickMarktingGuide');
        return this.get(url, {
            group_id: params.groupId,
        }, { timeout: 2 * 60 * 1000 });
    }
    async createQuickMarktingGroup(parmas) {
        console.log('[addressBookNewApiImpl] createQuickMarktingGroup', parmas);
        const url = this.systemApi.getUrl('createQuickMarktingGroup');
        return this.post(url, parmas);
    }
    async deleteQuickMarktingGroup(parmas) {
        const url = this.systemApi.getUrl('deleteQuickMarktingGroup');
        await this.get(url, {
            group_id: parmas.groupId,
        });
    }
    async cancelGroupEdm(groupIds) {
        const url = this.systemApi.getUrl('cancelGroupEdm');
        await this.post(url, {
            group_ids: groupIds,
        });
    }
    setGroupCollect(param) {
        return this.post(this.systemApi.getUrl('setGroupCollect'), param);
    }
    async getNewAddressRecycleList(params) {
        const url = this.systemApi.getUrl('addressRecycleList');
        return this.get(url, params);
    }
    async emptyAddressRecycle() {
        return this.post(this.systemApi.getUrl('emptyAddressRecycle'), {});
    }
    async recoverAddressRecycle(recycleIds) {
        const url = this.systemApi.getUrl('recoverAddressRecycle');
        await this.post(url, {
            recycle_contact_ids: recycleIds,
        });
    }
    async deleteAddressRecycle(recycleIds) {
        const url = this.systemApi.getUrl('deleteAddressRecycle');
        await this.post(url, {
            recycle_contact_ids: recycleIds,
        });
    }
    async getRecycleDetail(recycleId) {
        const url = this.systemApi.getUrl('getAddressRecycleDetail');
        return this.get(url, { recycle_contact_id: recycleId });
    }
    async getAllContactGroupList(filterDefaultGroup = true, isCollect) {
        const collectReq = isCollect ? { collect: true } : {};
        return this.getGroupList(Object.assign({ page: 1, page_size: 100 }, collectReq)).then(groupList => !filterDefaultGroup ? groupList : groupList.filter(item => item.group_type !== 0));
    }
    async getAllCreateTypeList() {
        return this.get(this.systemApi.getUrl('addressBookGetConfigDictionary')).then((res) => {
            const createTypes = res.contact_create_type || [];
            return createTypes.map((createType) => ({
                id: createType.value,
                label: createType.label,
            }));
        });
    }
    async getMarktingFiltedEmails(params, config) {
        const url = this.systemApi.getUrl('getEdmContactList');
        const reqConfig = config || {};
        const groupedFilter = params.groupedFilter ? cloneDeep(params.groupedFilter) : { relation: 'AND', subs: [] };
        const list = await this.post(url, {
            groupedFilter,
        }, reqConfig);
        if (lodashGet(list, 'length', 0) > 0) {
            return list;
        }
        return [];
    }
    async getGroupCountByFilter(params) {
        const url = this.systemApi.getUrl('getGroupCountByFilter');
        const groupedFilter = params.filter ? cloneDeep(params.filter) : { relation: 'AND', subs: [] };
        const count = await this.post(url, {
            filter: groupedFilter,
            functionType: 'LEADS_CONTACT',
            viewType: 'MY_LEADS_CONTACT',
        });
        return count;
    }
    static getMarktingHistory(item) {
        if (!item.edm_email_statistic) {
            return '';
        }
        let result = '';
        const edmEmailStatistic = item.edm_email_statistic;
        if (edmEmailStatistic.delivery_count && edmEmailStatistic.delivery_count > 0) {
            result = `发送过${edmEmailStatistic.send_count}，送达过${edmEmailStatistic.delivery_count}次`;
            return result;
        }
        if (edmEmailStatistic.send_count && edmEmailStatistic.send_count > 0) {
            return '未送达';
        }
        return '未营销';
    }
    static computeMarktingHistory(item, defaultMailMarkingHistoryStr) {
        let result = '';
        const edmEmailStatistic = item.edm_email_statistic;
        if (edmEmailStatistic.delivery_count && edmEmailStatistic.delivery_count > 0) {
            result = `发送过${edmEmailStatistic.send_count}，送达${edmEmailStatistic.delivery_count}次`;
            return result;
        }
        if (edmEmailStatistic.send_count && edmEmailStatistic.send_count > 0) {
            return '未送达';
        }
        return defaultMailMarkingHistoryStr;
    }
    async searchContactList(inParam) {
        var _a, _b;
        await this.initCreateTypeMap();
        const param = inParam ? cloneDeep(inParam) : inParam;
        if (param) {
            const defaultEmailFilter = {
                id: 'email',
                condition: {
                    method: 'IS_NOT_EMPTY',
                    value: '',
                },
                table: 'leads_contact',
            };
            if (param.groupFilter && param.groupFilter.subs) {
                param.groupedFilter = param.groupFilter;
                delete param.groupFilter;
            }
            else {
                param.groupedFilter = undefined;
            }
            if (!param.quickFilter || !param.quickFilter.subs) {
                param.quickFilter = {
                    relation: 'AND',
                    subs: [defaultEmailFilter],
                };
            }
            if (!param.filter || !param.filter.subs) {
                param.filter = {
                    relation: 'AND',
                    subs: [defaultEmailFilter],
                };
            }
            else {
                param.filter.subs.push(defaultEmailFilter);
            }
            const defaultSort = {
                field_id: 'contact_id',
                reverse: true,
            };
            if (!param.sort) {
                param.sort = defaultSort;
            }
            param.step_forward = param.stepForward;
            delete param.stepForward;
            if (param.page * param.page_size > 10000) {
                if (param.step_forward) {
                    param.sortValues = (_a = param.sortValues) === null || _a === void 0 ? void 0 : _a.firstSortValues;
                }
                else {
                    param.sortValues = (_b = param.sortValues) === null || _b === void 0 ? void 0 : _b.lastSortValues;
                }
            }
            else {
                delete param.step_forward;
                delete param.sortValues;
            }
        }
        return this.post(this.systemApi.getUrl('addressBookGetMyContactList'), param, { timeout: 2 * 60 * 1000 }).then((res) => {
            const dataList = res.content || [];
            const timeFormatStr = 'YYYY-MM-DD HH:mm:ss';
            return {
                ascFlag: res.asc_flag,
                totalCount: res.total_size,
                page: res.page,
                pageSize: res.page_size,
                firstSortValues: res.firstSortValues,
                lastSortValues: res.lastSortValues,
                list: dataList.map((item) => {
                    const defaultMailMarkingHistoryStr = '未营销';
                    const mailMarketingHistoryStr = item.edm_email_statistic
                        ? AddressBookNewApiImpl.computeMarktingHistory(item, defaultMailMarkingHistoryStr)
                        : defaultMailMarkingHistoryStr;
                    let mailMarketHistoryStatus = '';
                    if (mailMarketingHistoryStr) {
                        if (mailMarketingHistoryStr !== defaultMailMarkingHistoryStr) {
                            if (mailMarketingHistoryStr.includes('发送过')) {
                                mailMarketHistoryStatus = 'success';
                            }
                            if (mailMarketingHistoryStr.includes('未送达')) {
                                mailMarketHistoryStatus = 'warn';
                            }
                        }
                    }
                    const newItem = Object.assign(Object.assign({}, item), { email: item.email, contactId: Number(item.contact_id), contactName: item.contact_name, groupNames: item.groups && item.groups.length
                            ? item.groups.map((groupItem) => ({
                                groupId: groupItem.id,
                                groupName: groupItem.group_name,
                                collect: groupItem.collect,
                            }))
                            : [], mailMarketHistoryStatus: mailMarketHistoryStatus, mailMarketingHistory: mailMarketingHistoryStr, area: item.area && item.area.length ? item.area.filter((item) => item).join('/') : '', orgAreaArray: item.area || [], companyName: item.leads_company_name, job: item.job, createTypeId: item.create_type, createTypeName: this.createTypeMap ? this.createTypeMap[item.create_type] || '' : '', createTime: item.create_time ? moment(item.create_time).format(timeFormatStr) : '', lastSendTime: item.edm_email_statistic && item.edm_email_statistic.latest_send_time ? moment(item.edm_email_statistic.latest_send_time).format(timeFormatStr) : '', leadsId: item.leads_id, leadsName: item.leads_name, sourcename: item.source_name, valid: !!item.valid });
                    return newItem;
                }),
            };
        });
    }
    async searchContactCount(param) {
        const defaultEmailFilter = {
            id: 'email',
            condition: {
                method: 'IS_NOT_EMPTY',
                value: '',
            },
            table: 'leads_contact',
        };
        const defaultSort = {
            field_id: 'contact_id',
            reverse: true,
        };
        const req = {
            page: 1,
            page_size: 20,
            sort: defaultSort,
            quickFilter: {
                relation: 'AND',
                subs: [...param, defaultEmailFilter],
            },
        };
        return this.post(this.systemApi.getUrl('addressBookGetMyContactCount'), req, { timeout: 2 * 60 * 1000 });
    }
    deleteContacts(req) {
        return this.post(this.systemApi.getUrl('addressBookDeleteAddressBookContacts'), req, { toastError: false });
    }
    batchDeleteContacts(req) {
        return this.post(this.systemApi.getUrl('addressBookBatchDeleteAddressBookContacts'), req);
    }
    asyncDeleteContactsByEmails(req) {
        return this.post(this.systemApi.getUrl('addressBookDeleteContactsByEmails'), req);
    }
    addContactsToGroup(req) {
        return this.post(this.systemApi.getUrl('addressBookAddContactToGroups'), req);
    }
    getEdmTaskAsyncCountConfig(req) {
        return this.get(this.systemApi.getUrl('getEdmTaskAsyncCountConfig'), req);
    }
    transferContactsToGroups(req) {
        return this.post(this.systemApi.getUrl('addressBookTransferContactsToGroup'), req);
    }
    batchAddGroups(req) {
        return Promise.all(req.groupNames.map(groupName => this.createGroup(groupName)));
    }
    getAddressBookContactDetail(params) {
        return this.get(this.systemApi.getUrl('getAddressBookContactDetail'), params);
    }
    async editAddressBookContact(params) {
        const res = await this.getAddressBookContactDetail({ contact_id: params.contact_id, leads_id: params.leads_id });
        if (params.attr === 'contactName') {
            res.contact_name = params.value;
        }
        else if (params.attr === 'groupNames') {
            res.groups = params.value.filter(_ => _.group_type !== 0);
        }
        else if (params.attr === 'area') {
            let area = [];
            for (let i = 0; i < 4; i++) {
                area.push(params.value[i] || '');
            }
            res.area = area;
            res.continent = area[0] || '';
            res.country = area[1] || '';
            res.province = area[2] || '';
            res.city = area[3] || '';
        }
        else {
            res[params.attr] = params.value;
        }
        if (params.attr !== 'groupNames') {
            res.groups = res.groups.filter(_ => _.group_type !== 0);
        }
        res.group_ids = res.groups.map((_) => _.id);
        return this.post(this.systemApi.getUrl('editContact'), res);
    }
    checkContactFieldUnique(params) {
        return this.get(this.systemApi.getUrl('checkContactFieldUnique'), params);
    }
}
const addressBookNewApiImpl = new AddressBookNewApiImpl();
api.registerLogicalApi(addressBookNewApiImpl);
export default addressBookNewApiImpl;
